import s from './FormField.module.scss';

type Props = {
  label: string;
  children: React.ReactNode;
};

/** Параметр в правой колонке формы: подпись слева, поле справа */
const FormField: React.FC<Props> = ({ label, children }) => (
  <div className={s.field}>
    <span className={s.field__label}>{label}</span>
    <div className={s.field__value}>{children}</div>
  </div>
);

export { FormField };
